import { fetch } from '@umu/umu-fetch';

interface IUploadImageToServerInput {
    media_id: string;
}

interface IUploadImageToServerOutput {
    data: {
        photo_url: string;
    };
    error_code: number;
    error?: string;
}

export function uploadImageToServer(param: IUploadImageToServerInput): Promise<IUploadImageToServerOutput> {
    const postData = Object.assign(
        {
            session_id: '0',
            media_id: '',
            title: 'image',
            rotate: 0,
            type: 2,
        },
        param,
    );
    return fetch.post('/ajax/result/uploadphoto', postData);
}
